import { FilterMatchMode, FilterOperator } from '@openvue/core/api'
import type GridConfiguration from '../types/GridConfiguration'

export const TrackerMonthlyConfiguration: GridConfiguration = {
  columns: [
    {
      field: 'code',
      header: 'Retailer Code',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'name',
      header: 'Retailer Name',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'used_funded_volume_total',
      header: 'Used Funded Volume Total',
      type: 'currency',
    },
    {
      field: 'used_selected_cases',
      header: 'No. of Used / Selected Used Cases',
      type: 'text',
    },
  ],
  settings: [
    { name: 'showDownloadDocument', value: false },
    { name: 'showDownloadSpreadsheet', value: true },
    { name: 'showMonthFilter', value: true },
    { name: 'showYearFilter', value: false },
    { name: 'showColumnSelect', value: true },
  ],
}
